<template>
  <div style="display:inline-block;">
    <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick" />
    <a-button type="primary" @click="handleUpload" style="margin-left: 8px;">{{ btnTitle }}</a-button>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    btnTitle: {
      default: '导入表格',
    },
    isStandard: {
      // 是否标准表格
      default: true,
    },
    beforeUpload: Function,
    onSuccess: Function,
  },
  data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: null,
      },
    };
  },
  methods: {
    generateData({ header, results }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.onSuccess && this.onSuccess(this.excelData);
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) {
        return;
      }
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error('一次只能上传一个文件!');
        return;
      }
      const rawFile = files[0];

      if (!this.isExcel(rawFile)) {
        this.$message.error('只支持 .xlsx, .xls, .csv 格式的文件!');
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) {
        return;
      }
      this.upload(rawFile);
    },
    upload(rawFile) {
      this.$refs['excel-upload-input'].value = null;
      if (!this.beforeUpload) {
        this.readerData(rawFile);
        return;
      }
      const before = this.beforeUpload(rawFile);
      if (before) {
        this.readerData(rawFile);
      }
    },
    readerData(rawFile) {
      this.$emit('start');
      this.loading = true;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          let header = [];
          let results = [];

          if (this.isStandard) {
            // 标准表格
            header = this.getHeaderRow(worksheet);
            results = XLSX.utils.sheet_to_json(worksheet);
          } else {
            // 去除首尾
            const orgResults = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: false });
            if (orgResults[0].length !== orgResults[1].length) {
              // orgResults.pop() // 去除尾行
              orgResults.shift(); // 去除首行
            }
            header = orgResults[0];
            const ws = XLSX.utils.aoa_to_sheet(orgResults);
            results = XLSX.utils.sheet_to_json(ws);
          }

          this.generateData({ header, results });
          this.loading = false;
          this.$emit('end');
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) {
          hdr = XLSX.utils.format_cell(cell);
        }
        headers.push(hdr);
      }
      return headers;
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
  },
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}
</style>
